
import api from '../../../api/client';
import { TABLE_PREFERENCE } from '../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../api/handlers';

export const getColumnPreference = async (tableKey) => {
    try {
        const response = await api.get(TABLE_PREFERENCE.SHOW(tableKey));
        return handleApiResponse(response);
    } catch (error) {
        return handleApiError(error);
    }
};

export const saveColumnPreference = async (tableKey, hiddenColumns, columnOrder) => {
    try {
        const body = { hidden_columns: hiddenColumns };
        if (columnOrder) body.column_order = columnOrder;

        const response = await api.put(TABLE_PREFERENCE.UPDATE(tableKey), body);
        return handleApiResponse(response);
    } catch (error) {
        return handleApiError(error);
    }
};